import { MenuItem } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React from "react";
import { useTranslation } from "react-i18next";

export default function Submission({
  id,
  tableColDetails,
  setTableColDetails,
  selectedValues,
  setIsOrable,
  label,
  color,
}) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const handleClick = async () => {
    const tmpDetail = [];
    await tableColDetails.forEach((value) => {
      if (value.name === "details4.clinvar_submission") {
        let count = value.activeFilterCount ?? 0;
        if (Object.keys(value.filterValues).length === 0) enqueueSnackbar(t("Clinvar submission filters are not found."), {
          variant: "warning",
        });
        Object.keys(value.filterValues).forEach((key) => {
          if (selectedValues.includes(key)) {
            value.filterValues[key] = true;
            count++;
          } else {
            value.filterValues[key] = false;
            enqueueSnackbar(t("Clinvar submission not found for this report {{variant}}.", { variant: key }), {
              variant: "warning",
            });
          }
        });
        value.activeFilterCount = count;
        value.representation.kind = "main_table_cell";
      }
      tmpDetail.push(value);
    });
    // setTableFilterState({ ...tableFilterState });
    setIsOrable(true);
    setTableColDetails([...tmpDetail]);
  };

  return <MenuItem id={id} onClick={handleClick}>{t(label)}</MenuItem>;
}
